import * as React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { getCookie } from "../../services/Cookies";
import { FilterObj } from '../CommonComponents/globalfilterObj';
export default function FuelOffSpec(props) {

    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
    const { globalfilter, screen, updateParent, reset, type } = props;
    const [formObj, setFormObj] = useState(FilterObj);
    const [selectedvalue, setselectedvalue] = React.useState([]);
    const [Offspec, setOffspec] = React.useState([]);

    const autoTextReportStatus = (event) => {
        // 
         let result = [
           { id: "Y", name: 'Yes' },
             { id: "N", name: 'No' },
           ]
        //  if (selectedvalue) {
        //      selectedvalue.forEach((val, i) => {
        //          result = result.filter((ele) => ele.name != val.name)
        //      })
        //  }
         setOffspec(result);
         
     }
    const handleChange = (event, newValue) => {
        
        props.onChange(newValue);
        const filteredFqtOffSpec = {
            ...formObj,
            FqtOffSpec: newValue
        };
        setFormObj(filteredFqtOffSpec);
        setselectedvalue(newValue);
        if (screen !== "GlobalFilter") {
            let Obj = JSON.parse(localStorage.getItem('FilterSetting'));
            Obj = {
                ...Obj,
                FqtOffSpec: newValue
            }
            localStorage.setItem("FilterSetting", JSON.stringify(Obj));
        }
    }
    const defaultValue = (val) => {
        ////
        let filtervalue = JSON.parse(localStorage.getItem('FilterSetting'));
        if (filtervalue !== "" && filtervalue !== undefined && filtervalue !== null && filtervalue !== "null" && screen !== "GlobalFilter") {
            const Obj = {
                ...formObj,
                FqtOffSpec: filtervalue.FqtOffSpec
            };
            setFormObj(Obj);
            setselectedvalue(filtervalue.FqtOffSpec);
        }
        else if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setFormObj(Obj);
            console.log('getcookievalue', formObj)
            setselectedvalue(Obj.FqtOffSpec);
        }else{
            setFormObj({});
        }
    }
    React.useEffect(() => {
        //
        if (reset>0)
            defaultValue(GlobalFilterSettingValue);

    }, [reset]);
    React.useEffect(() => {
        ////
        defaultValue(GlobalFilterSettingValue);
        autoTextReportStatus();
    }, []);
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                value={formObj?.FqtOffSpec || []}
                getOptionSelected={(option, value) => option?.name === value?.name}
                options={Offspec}
                getOptionLabel={(option) => option?.name}

                onChange={(event, newValue) => handleChange(event, newValue)}

                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="OffSpec result only"
                        //placeholder="Favorites"
                        onChange={autoTextReportStatus}

                    />
                )}
            />


        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
